import { Component, OnInit, TemplateRef } from '@angular/core';
import { ProductoService } from '../../../services/producto.service';
import { Producto } from '../../../models/producto';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Validation } from '../../../config/validation';
import { CostoVenta } from '../../../models/costo-venta';
import { PrecioVenta } from '../../../models/precio-venta';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { PrecioAdicionalModalComponent } from '../../modals/precio-adicional-modal/precio-adicional-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-precios-edit',
    templateUrl: './precios-edit.component.html',
    styleUrls: ['./precios-edit.component.css'],
    providers: [ProductoService, SessionService, ParametroService]
})
export class PreciosEditComponent implements OnInit {
    public producto: Producto;
    public loading: boolean;
    myForm: FormGroup;
    public precio_venta: number;
    public precio_costo: number;
    public incluye_iva: boolean;
    public vl: Validation;
    public costos: Array<CostoVenta>;
    public precios: Array<PrecioVenta>;
    public msgSweet: SweetMessage;
    public bsModalRef: BsModalRef;
    public is_precios: boolean;
    public numero_decimales: number;
    public format_decimal: String;

    constructor(
        private productoService: ProductoService,
        private storage: AsyncLocalStorage,
        public ss: SessionService,
        private modalService: BsModalService,
        private parametroService: ParametroService,
    ) {
        this.producto = new Producto();
        this.precio_venta = 0;

        this.incluye_iva = false;
        this.precio_costo = 0;
        this.costos = [];
        this.precios = [];
        this.msgSweet = new SweetMessage();
        this.vl = new Validation();
        this.is_precios = false;

        this.numero_decimales = 2;
        this.format_decimal = "0,0.00";

        this.loading = true;

        let p1 = this.getParamNumeroDecimales();
        let p2 = this.getPreciosAdicionales();

        Promise.all([p1, p2]).then(
            res => this.loading = false,
            err => this.loading = false
        )
    }

    ngOnInit() {
        this.storage.getItem("productosprecios").subscribe(data => {
            this.producto = data;

            if (this.producto.precios.length > 0) {
                this.precio_venta = parseFloat(this.producto.precios[0].precio.toString());
            }

            if (this.producto.costos.length > 0) {
                this.precio_costo = parseFloat(this.producto.costos[0].precio.toString());
            }
        });
    }

    getPreciosAdicionales() {
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_adicional_id = 16;
            this.parametroService.getById(precio_adicional_id).subscribe(
                res => {
                    this.is_precios = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_precios = false;
                    reject(err);
                }
            );
        });
    }

    onSubmit() {
        this.setValueEntity();
        this.loading = true;
        this.productoService.PrecioCosto(this.producto).subscribe(
            res => {
                this.loading = false;
                this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
            },
            err => {
                this.loading = false;
                this.msgSweet.showMessage('error-message', err);
            }
        );

    }

    setValueEntity() {

        let costo = new CostoVenta();
        costo.precio = this.precio_costo.toString();
        costo.producto_id = this.producto.id;
        costo.empresa_id = this.ss.getData('empresa_id');
        costo.usuario_id = this.ss.getData('usuario_id');
        this.costos.push(costo);

        this.producto.costos = this.costos;

        let precio = new PrecioVenta();
        precio.precio = this.precio_venta.toString();
        precio.incluye_iva =this.incluye_iva;

        precio.producto_id = this.producto.id;
        precio.empresa_id = this.ss.getData('empresa_id');
        precio.usuario_id = this.ss.getData('usuario_id');

        this.precios=[];
        this.precios.push(precio);

        this.producto.precios = this.precios;

    }

//     cambiarEstado(event: any) {
//        /* let precio = new PrecioVenta();
//         this.incluye_iva = event.currentTarget.checked;
//         if () {
// */
//             this.incluye_iva = event.currentTarget.checked;
//        /*     this.precios.push(precio);


//         }else{
//             this.incluye_iva =false;
//         }*/

//     }

    onPreciosAdicionales() {
        const initialState = { producto: this.producto, numero_decimales: this.numero_decimales };
        this.bsModalRef = this.modalService.show(PrecioAdicionalModalComponent,Object.assign({}, {class: 'modal-sm', initialState }));

    }


    // setValueForm() {
    // 	this.myForm.setValue({

    // 		incluye_iva: this.producto.incluye_iva,
    // 		graba_iva: this.producto.graba_iva,
    // 		precio_venta: this.producto.precio,
    // 		precio_costo: this.producto.costo,
    // 	});
    // } 

    getParamNumeroDecimales() {
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for (let i = 0; i < this.numero_decimales; i++) digitos += "0";
                    this.format_decimal = "0,0." + digitos;
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/precios-edit/precios-edit.component.ts